import { Grid, Typography } from '@mui/material'
import React from 'react'
import useStyles from '../useStyles'
import FolderUsersTable from './TableNavigable/FolderUsersTable'
export const BoxFolderUsersDetails = ({ folderUsers, loading }) => {
  const classes = useStyles()
  return (
    <Grid container className={classes.boxDetails}>
      <Grid item xs={12}>
        <Typography
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: '#4B4952',
            paddingLeft: 10,
            borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
          }}
        >
          Carpeta de sistema de los usuarios asociados
        </Typography>
      </Grid>
      {!loading && <FolderUsersTable folderUsers={folderUsers} />}
    </Grid>
  )
}
